<template>
    <a class="post-item" :href="post.url">
        <div class="post-item__inner">
            <div class="post-item__media">
                <div class="post-item__intrinsic-ratio" v-if="post.image">
                    <img
                        class="post-item__image"
                        :srcset="`${imageUrl(post, {width: 300, height: 220 })} 300w, ${imageUrl(post, {width: 640, height: 469 })} 640w, ${imageUrl(post, {width: 1280, height: 939 })} 1280w`"
                        sizes="(max-width: 799px) 50vw, (max-width: 999px) 33vw, 25vw"
                        :src="`${imageUrl(post, {width: 430, height: 315 })}`"
                        width="1280"
                        height="939"
                        :alt="post.image.alt"
                    />
                </div>
            </div>
            <div class="post-item__info">
                <div class="post-item__content">
                    <span class="post-item__prefix">{{ post.theme?.settings?.prefix }}</span>
                    <h2 class="post-item__title">{{ post.title }}</h2>
                </div>
            </div>
            <span class="post-item__date" v-if="postDate">{{ postDate }}</span>
        </div>
    </a>
</template>

<script>
import { defineComponent, ref, watch, inject} from 'vue';

export default defineComponent({
    name: 'PostItemHub',
    props: {
        post: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const post = ref({});
        const imageUrl = inject('imageUrl');
        const postDate = ref(null);

        watch(
            () => props.post,
            (newPost) => {
                post.value = newPost;

                if (post.value.publishDate) {
                    const date = new Date(post.value.publishDate);

                    postDate.value = date.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric'
                    });
                } else {
                    postDate.value = null;
                }
            },
            { immediate: true }
        );

        return {
            post: post,
            postDate: postDate,
            imageUrl: imageUrl
        }
    }
});
</script>


